import * as yup from 'yup'

/**
 * CUSTOM VALIDATE FIELD
 */
yup.addMethod(yup.string, "validateProject", function (is_project) {
    return this.test(`test-validate-project`, is_project, function (values) {
        const { path, createError } = this;

        var message = "project_name is a required field"
        var project = this.resolve(is_project)

        return (
            (project !== "Sim" || values) ||
            createError({ path, message: message })
        );
    });
});


yup.addMethod(yup.string, "validateField", function (field) {
    return this.test(`test-validate-project`, field, function (values) {
        const { path, createError } = this;

        var message = "field is a required field"
        var project = this.resolve(field)

        return (
            (project || values) ||
            createError({ path, message: message })
        );
    });
});


yup.addMethod(yup.string, "validateMask", function (type) {
    return this.test(`test-validate-project`, type, function (values) {
        const { path, createError } = this;

        var message = "mask is a required field"
        var data_type = this.resolve(type)

        return (
            (data_type === "string" || values) ||
            createError({ path, message: message })
        );
    });
});


yup.addMethod(yup.string, "validateMaskRequired", function (fieldTypeData, typesData) {
    return this.test(`test-validate-project`, fieldTypeData, function (values) {
        const { path, createError } = this;

        var message = "field is required"
        var field_type_data = this.resolve(fieldTypeData)

        return (
            (!typesData.includes(field_type_data) || values) ||
            createError({ path, message: message })
        );
    });
});


yup.addMethod(yup.string, "checkIfCompanyEmail", function () {
    return this.test(`check-if-company-email`, function (values) {
        const { path, createError } = this;

        var message = "only company email is allowed"
        var result = false

        if (values !== undefined) {
            const domain = values.split("@")
            const domainAllowed = ["avon.com", "thebodyshop.com", "aesop.com", "aesop.com.br", "thebodyshop.com.br", "natura.net"]

            result = (domain.length > 1) ? domainAllowed.includes(domain[1]) : false

            console.log("result", result, 'domain', domain, domain.length)
        }

        return (
            (result) ||
            createError({ path, message: message })
        );
    });
});


yup.addMethod(yup.object, 'uniqueProperty', function (propertyName, message) {
    return this.test('unique', message, function (value) {
      if (!value || !value[propertyName]) {
        return true;
      }

      if (
        this.parent
          .filter(v => v !== value)
          .some(v => v[propertyName] === value[propertyName])
      ) {
         throw this.createError({
           path: `${this.path}.${propertyName}`,
         });
      }
  
      return true;
    });
});


yup.addMethod(yup.string, "validateTwoFields", function (field, message) {
    return this.test(`test-validate-project`, field, function (values) {
        const { path, createError } = this;

        // var message = "The emails must be equals"
        var field1 = this.resolve(field)
        var field2 = values
    
        return (
            (field1 === field2) ||
            createError({ path, message: message })
        );
    });
});


/**
 * schema de validação do formulario de requisição
 */
export const requestingSchema = yup.object().shape({
    requesting_name: yup.string().required(),
    requesting_email: yup.string().required(),
    requesting_area: yup.string().required(),
    requesting_company: yup.string().required(),
    is_project: yup.string().required(),
    project_name: yup.string().validateProject(yup.ref('is_project')),
    justification_ingestion: yup.string().required(),
});

/**
 * schema de validação do formulario de definição
 */
export const definitionSchema = yup.object().shape({
    // responsible_for_business_data: yup.string().required(),
    // area_for_business_data: yup.string().required(),
    responsibles: yup.array().of(
        yup.object().shape({
          name: yup.string().required("name required").matches(/^[a-zA-Z0-9À-ÿ\s]+$/, "Only letters and number are allowed."),
          email: yup.string().checkIfCompanyEmail().max(100).required("email required"),
          area: yup.string().required("name required").matches(/^[a-zA-Z0-9À-ÿ\s]+$/, "Only letters and number are allowed.")
        }).uniqueProperty('email', 'you must specify a unique email.'),
    ),
    company: yup.string().required(),
    domain_data: yup.string().required(),
    subject_data: yup.string().required(),
    public_data: yup.string().required(),
});

/**
 * schema de validação do formulario do arquivo
 */
export const fileSchema = yup.object().shape({
    entity_name: yup.string().required(),
    desc_entity: yup.string().required(),
    extension_file: yup.string().required(),
    delimiter: yup.string().required(),
    encoding: yup.string().required(),
    maximum_data_history_time: yup.number().required(),
    maximum_data_history_time_unit: yup.string().required(),
    frequency: yup.string().required(),
    type_load: yup.string().required(),
});

// schema de validação do campo de validação
export const fieldSchema = yup.object().shape({
    id: yup.string().required(),
    name_field: yup.string().required(),
    data_type: yup.string().required(),
    des_field: yup.string().required(),
    descriptionCode: yup.string(),
    LGPD: yup.string().required(),
    example: yup.string().required(),
    mask_field: yup.string().validateMask(yup.ref('data_type')),

    month: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterDate: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    sequence: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    sample_mask: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterDateTime: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterTime: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),

    booleanTrue: yup.string().validateMaskRequired(yup.ref('data_type'), 'boolean'),
    booleanFalse: yup.string().validateMaskRequired(yup.ref('data_type'), 'boolean')
})


// schema de validação do campo de validação
export const fieldIntegrationLayerSchema = yup.object().shape({
    id: yup.string().required(),
    name_field: yup.string().required(),
    datalake_field_name: yup.string(),
    data_type: yup.string().required(),
    des_field: yup.string().required(),
    mask_field: yup.string().validateMask(yup.ref('data_type'))
});


export const manualFileSchema =  yup.object().shape({
    requesting_name: yup.string().required(),
    requesting_email: yup.string().required(),
    requesting_area: yup.string().required(),
    requesting_company: yup.string().required(),
    is_project: yup.string().required(),
    project_name: yup.string().validateProject(yup.ref('is_project')),
    justification_ingestion: yup.string().required(),

    // responsible_for_business_data: yup.string().required(),
    // area_for_business_data: yup.string().required(),
    responsibles: yup.array().of(
        yup.object().shape({
          name: yup.string().required("name required").matches(/^[a-zA-Z0-9À-ÿ\s]+$/, "Only letters and number are allowed."),
          email: yup.string().checkIfCompanyEmail().max(100).required("email required"),
          area: yup.string().required("name required").matches(/^[a-zA-Z0-9À-ÿ\s]+$/, "Only letters and number are allowed.")
        }).uniqueProperty('email', 'you must specify a unique email.'),
    ),
    company: yup.string().required(),
    domain_data: yup.string().required(),
    subject_data: yup.string().required(),
    public_data: yup.string().required(),

    entity_name: yup.string().required(),
    desc_entity: yup.string().required(),
    extension_file: yup.string().required(),
    delimiter: yup.string().required(),
    maximum_data_history_time: yup.number().required(),
    maximum_data_history_time_unit: yup.string().required(),
    frequency: yup.string().required(),
    type_load: yup.string().required(),

    month: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterDate: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    sequence: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    sample_mask: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterDateTime: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),
    delimiterTime: yup.string().validateMaskRequired(yup.ref('data_type'), ['date', 'datetime']),

    booleanTrue: yup.string().validateMaskRequired(yup.ref('data_type'), 'boolean'),
    booleanFalse: yup.string().validateMaskRequired(yup.ref('data_type'), 'boolean')
});


// define o schema de validação do login
export const LoginSchema = yup.object().shape({
    pk_user: yup.string().email('must be a valid email').max(100).required(),
    password: yup.string().required(),
});


export const IntegrationLayerSchema = yup.object().shape({
    entity_name: yup.string().required(),
    system_name: yup.string().required(),
    chunk_size: yup.number().required(),
    pattern_file: yup.string().required(),
    extension_file: yup.string().required(),
    pattern_date: yup.string().required().matches(/[^A-Z]+$/, "only lowercase letters"),
    type_file: yup.string().required(),
    encoding: yup.string().required(),
    delimiter: yup.string().required().max(2),
    content_delimiter: yup.string().max(2).required(),
    account_destination : yup.string().required(),
    datalake_destination: yup.string().required(),
    datalake_table_name: yup.string(),
    email_notification_account: yup.string().validateField(yup.ref('group_id')),
    source_path: yup.string().required(),
    active: yup.boolean().required(),
    header: yup.boolean().required(),
    schedule_interval: yup.string().required(),
    crontab: yup.string().validateMaskRequired(yup.ref('schedule_interval'), ['crontab']),
    schedule_delta: yup.string().required(),
    category_id: yup.string().validateField(yup.ref('email_notification_account')),
    group_id: yup.string().validateField(yup.ref('email_notification_account')),
    open_ticket: yup.boolean().required(),
    processed_path: yup.string(),
    tag_set: yup.array().of(
        yup.object().shape({
          Key: yup.string().required("Key required"),
          Value: yup.string().required("Value required")
        }).uniqueProperty('Key', 'You must specify a unique tag key.'),
    )
});

export const ILSearchSchema = yup.object().shape({
    type_query: yup.string().required(),
    entity_name: yup.string().validateMaskRequired(yup.ref('type_query'), ['query']),
    system_name: yup.string(),
    condition: yup.string().validateMaskRequired(yup.ref('type_query'), ['query']),
    filters: yup.array().of(
        yup.object().shape({
            attribute: yup.string(),
            value: yup.string(),
            condition: yup.string()
        })
    )
});


// define o schema de validação do login
export const UpdateUserSchema = yup.object().shape({
    email: yup.string().email('must be a valid email').max(100).required(),
    first_password: yup.string().required().matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Sua senha deve ter pelo menos 8 caracteres e conter: uma letra maiúscula, uma letra minúscula, um número e um caractere especial (!@#$%^&*)"
      ),
    second_password: yup.string().validateTwoFields(yup.ref('first_password'), 'The passwords must be equals').required(),
    racf: yup.string().required(),
    last_name: yup.string().required(),
    given_name: yup.string().required()
});

export const CreateUserSchema = yup.object().shape({
    email: yup.string().email('must be a valid email').max(100).required()
});


// define o schema de validação do login
export const ResetPasswordSchema = yup.object().shape({
    email: yup.string().email('must be a valid email').max(100).required(),
    first_password: yup.string().required().matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Sua senha deve ter pelo menos 8 caracteres e conter: uma letra maiúscula, uma letra minúscula, um número e um caractere especial (!@#$%^&*)"
      ),
    second_password: yup.string().validateTwoFields(yup.ref('first_password'), 'The passwords must be equals').required()
});


export const SystemS3Schema = yup.object().shape({
    system_name: yup.string().required(),
    active: yup.string().required(),
    company: yup.string().required(),
    desc_system: yup.string().required(),
    host: yup.string().required(),
    system_type: yup.string().required()
});


export const SystemSFTPSchema = yup.object().shape({
    system_name: yup.string().required(),
    active: yup.string().required(),
    company: yup.string().required(),
    desc_system: yup.string().required(),
    host: yup.string().required(),
    key_sm: yup.string().required(),
    port: yup.number().integer().required(),
    system_type: yup.string().required(),
    scan_unprocessed_files: yup.string().required()
});


export const SystemAPISchema = yup.object().shape({
    system_name: yup.string().required(),
    active: yup.string().required(),
    base_url: yup.string().required(),
    company: yup.string().required(),
    desc_system: yup.string().required(),
    key_sm: yup.string().required(),
    system_type: yup.string().required()
});


